import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { commonQueryKeys } from "@/common/data/commonQueryKeys";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";

export function useAdminOrgDeleteMutation(orgId: string) {
  const queryClient = useQueryClient();

  return useMutation<object, AxiosError<ErrorResponse>>({
    mutationKey: ["admin", "org", orgId, "delete"],
    mutationFn: () =>
      api.delete<"/admin/:orgId">(`/admin/${orgId}`).then((res) => res.data),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: commonQueryKeys.orgs });
    },
  });
}
